var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 5.00002H15.8333V11.6667C15.8333 12.125 15.4583 12.5 15 12.5H4.99996V13.3334C4.99996 14.25 5.74996 15 6.66663 15H15L18.3333 18.3334V6.66669C18.3333 5.75002 17.5833 5.00002 16.6666 5.00002ZM14.1666 9.16669V3.33335C14.1666 2.41669 13.4166 1.66669 12.5 1.66669H3.33329C2.41663 1.66669 1.66663 2.41669 1.66663 3.33335V14.1667L4.99996 10.8334H12.5C13.4166 10.8334 14.1666 10.0834 14.1666 9.16669Z",
    fill: "#C650EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.decc60c6a7c6230a5267d1b9dab0a37a.svg";
export { ForwardRef as ReactComponent };